<template>
  <div class="createSkill-box">
    <div class="createSkillLeft"></div>
    <div class="createSkillRight">
      <div id="createSkill">
        <p class="title">创建技能</p>
        <div class="SkillContainer">
          <div>
            <el-form ref="form" :rules="developerInfo" :model="skillInfo" label-width="100px" style="width: 70%;">
              <el-form-item label="技能类型">
                <!--<el-input placeholder="自定义" disabled></el-input>-->
                <!--<el-button type="default" :class="skillInfo.open_skill_type == 0 ? 'btnActive' : null" class="little-btn" size="mini" round @click="skillType(0)">原始技能</el-button>-->
                <el-button type="default" :class="skillInfo.open_skill_type == 1 ? 'btnActive' : null" class="little-btn" size="mini" round @click="skillType(1)">自定义</el-button>
                <el-button type="default" :class="skillInfo.open_skill_type == 2 ? 'btnActive' : null" class="little-btn" size="mini" round @click="skillType(2)">智能家居</el-button>
              </el-form-item>
              <el-form-item  label="技能名称" prop="chinese_name">
                <el-tooltip content="请输入技能名称，支持中英文，2~50个字符" placement="top">
                  <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()" ></i>
                </el-tooltip>
                <el-input  @input="canClick()" placeholder="请输入技能名称" v-model.trim="skillInfo.chinese_name" @blur="nameBlur"></el-input>
              </el-form-item>
              <el-form-item label="技能标识" prop="domain">
                <el-tooltip content="请输入技能标识名称，2~50个字符，英文数字和_组合,不可重复" placement="top">
                  <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                </el-tooltip>
                <el-input @input="canClick()"  placeholder="请输入技能标识名称" v-model.trim="skillInfo.domain" @blur="signBlur"></el-input>
              </el-form-item>
              <el-form-item label="技能分类" prop="category" @change="canClick()">
                <!--:disbaled="skillInfo.type == 2"-->
                <el-cascader
                  :disabled="skillInfo.open_skill_type == 2"
                  :options="options"
                  :show-all-levels="false"
                  placeholder="请选择"
                  v-model.trim="skillInfo.category"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="技能图标" prop="chinese_name">
                <el-upload
                  class="avatar-uploader"
                  :before-upload="beforeFileUpload"
                  :action="uploadUrl()"
                  :show-file-list="false"
                  :on-success="uploadSuccess">
                  <img v-if="skillInfo.skill_icon_url" :src="skillInfo.skill_icon_url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                支持png、jpg、jpeg、bmp格式，最大不能超过2M，建议为320×320
              </el-form-item>
              <el-form-item label="技能简介" prop="skill_intro">
                <el-input @input="canClick()" type="textarea" placeholder="简单介绍该技能应用场景, 20~500字符" :autosize="{ minRows: 4, maxRows: 9}" v-model.trim="skillInfo.skill_intro"></el-input>
              </el-form-item>
            </el-form>

          </div>
          <el-button type="primary" class="intentSavebtn" style="font-size: 14px" round @click="createdSkill" size="mini" :disabled="flag">完成</el-button>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
  import qs from 'qs'
  import config from '@/config/index'
  import {createdSkillApi, skillName, getUserId, nameRepeatApi,signRepeatApi} from '@/api'
    export default {
        data() {
          var checkDis = (rule, value, callback) => {
            setTimeout(() => {
              var reg = new RegExp("^[a-zA-Z0-9_]+$");
              if (!reg.test(value)) {
                callback(new Error('请输入技能标识名称，2~50个字符，英文数字和_组合,不可重复'));
              } else {
                callback();
              }
            }, 100);
          }
          var checkChinese = (rule, value, callback) => {
            setTimeout(() => {
              var reg = new RegExp("^[\u4e00-\u9fa5a-zA-Z]+$");
              if (!reg.test(value)) {
                callback(new Error('技能名称支持中英文,2~50个字符'));
              } else {
                callback();
              }
            }, 100);
          }
            return {
              skill_id: '',
              dev_id: '',
              flag:true,
              skillInfo: {
                open_skill_type: 1,
                chinese_name: '',
                domain: '',
                category: [],
                skill_icon_url: '',
                skill_intro: ''
              },
              options: [],
              developerInfo: {
                chinese_name: [
                  { required: true, message: '请输入技能名称', trigger: 'blur' },
                  { min: 2, max: 50, message: '长度在 2 到 50 个汉字', trigger: 'blur' },
                  {validator: checkChinese, trigger: 'blur'}
                ],
                domain: [
                  { required: true, message: '请输入技能标识', trigger: 'blur'},
                  { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' },
                  {validator: checkDis, trigger: 'blur'}
                ],
                category: [
                  {type: 'array', required: true, message: '请选择技能分类', trigger: 'blur'}
                ],
                skill_intro: [
                  {required: true, message: '请输入技能简介，20~500个字符', trigger: 'blur'},
                  { min: 20, max: 500, message: '长度在 20 到 500 个字符', trigger: 'blur' }
                ]
              }
            }
            },
        created () {
          this.SkillName()
          this.getUserId()
          this.canClick()//所有内容为必填项, 未输入完全, “完成”置灰,不可点击
          this.tabindexNumChange()
        },
        methods: {
            skillType (type) {
                this.$set(this.skillInfo, 'open_skill_type', type)
               if (type == 2) {
                   this.skillInfo.category = ["智能家居", "智能家居"]
               } else {
                   this.skillInfo.category = []
               }
            },
          //所有内容为必填项, 未输入完全, “完成”置灰,不可点击
          canClick(){
            if (this.skillInfo.chinese_name == '' || this.skillInfo.domain == '' ||this.skillInfo.category.length == 0||this.skillInfo.skill_icon_url.length == 0||this.skillInfo.skill_intro == ''){
              this.flag=true;
            }else{
              this.flag=false;
            }
          },
          uploadUrl () {//动态写入图片地址
            return `${config.host}/user/upload`
          },
          beforeFileUpload(file) {
            let type = file.type.slice(file.type.lastIndexOf('/')+1)
            if(type !== 'jpg' && type !== 'png' && type !== 'jpeg' && type !== 'bmp'){
              this.$message.error('请上传指定格式得图片!');
              return false
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
              this.$message.error('上传头像图片大小不能超过 2MB!')
              return false
            }
            // const isLt50KB = file.size / 1024 < 50
            // if (isLt50KB) {
            //   this.$message.error('上传头像图片大小不能小于50KB!');
            //   return false;
            // }
          },
          tabindexNumChange(){
            this.tabindexNum = "-1"
          },
          //技能名称重复检验
          async nameBlur () {
            if (this.skillInfo.chinese_name == '') return
            let res = await nameRepeatApi(qs.stringify({'skill_name': this.skillInfo.chinese_name}))
            if (res.data.code != 200) {
                if (res.data.errors.length == 0) {
                    this.$message({message: '当前网络状况异常，请稍后再试', type: 'error'})
                } else {
                    this.$message({message: res.data.errors.data, type: 'error'})
                }
              return
            }
          },
          //技能标识重复检验
          async signBlur(){
            if (this.skillInfo.domain == '') return
            let res = await signRepeatApi(qs.stringify({'skill_domain': this.skillInfo.domain}))
            if (res.data.code != 200) {
                if (res.data.errors.length == 0) {
                    this.$message({message: '当前网络状况异常，请稍后再试', type: 'error'})
                } else {
              this.$message({message: res.data.errors.data, type: 'error'})
                }
              return
            }
          },
          async getUserId () {//获取用户id skillId
            let res = await getUserId()
            if (res.data.code == 200) {
              this.dev_id = res.data.data.id
              this.skill_id = this.$route.query.skillId
            } else {
              this.$message.error('您的token值过期，请重新登录')
            }

//            this.$route.query.skillId ? void(0) : this.$router.push('/skillList')

          },

          uploadSuccess (res, file, fileList) {
            this.skillInfo.skill_icon_url = res.data.url
//            console.log(this.skillInfo.skill_icon_url)
            //所有内容为必填项, 未输入完全, “完成”置灰,不可点击
            if (this.skillInfo.chinese_name == '' || this.skillInfo.domain == '' ||this.skillInfo.category.length == 0||this.skillInfo.skill_icon_url.length == 0||this.skillInfo.skill_intro == ''){
              this.flag=true;
            }else{
              this.flag=false;
            }

          },
          async createdSkill () {
            let regIntent = /^[0-9a-zA-Z_]+$/;
            let regSkillName=/[^\u4e00-\u9fa5a-zA-Z]/g;
            if (regSkillName.test(this.skillInfo.chinese_name) || this.skillInfo.chinese_name == '' || this.skillInfo.chinese_name.length < 2 || this.skillInfo.chinese_name.length > 50){
//              this.$message({message: '技能名称仅支持2~50个汉字', type: 'error'})
              this.$root.scroll_top();
              return
            } else if (!regIntent.test(this.skillInfo.domain) || this.skillInfo.domain == '' || this.skillInfo.domain.length < 2 || this.skillInfo.domain.length > 50) {
//              this.$message({message: '请输入技能标识名称，2~50个字符，英文数字和_组合,不可重复', type: 'error'})
              this.$root.scroll_top();
              return
            } else if (this.skillInfo.category.length == 0) {
              this.$message({message: '请选择技能分类', type: 'error'})
              return
            } else if (this.skillInfo.skill_icon_url.length == 0) {
              this.$message({message: '请选择技能图标', type: 'error'})
              return
            } else if (this.skillInfo.skill_intro == '' || this.skillInfo.skill_intro.length < 20 || this.skillInfo.skill_intro.length > 500) {
              //console.log(this.skillInfo.skill_intro);
//              this.$message({message: '请输入技能简介,长度在20~500字符之间', type: 'error'})
              return
            }
            let da = await nameRepeatApi(qs.stringify({'skill_name': this.skillInfo.chinese_name}))
            let sign=await signRepeatApi(qs.stringify({'skill_domain': this.skillInfo.domain, 'skill_id': this.skill_id}))//技能标识查重
            if (da.data.code != 200) {
              this.$message({message: da.data.errors.data, type: 'error'})
              return
            }
            if(sign.data.code!=200){
              this.$message({message: sign.data.errors.data, type: 'error'})
              return
            }

            let str = this.skillInfo.category.join(',')
            let req = JSON.parse(JSON.stringify(this.skillInfo))
            req.category = str
            req.dev_id = this.dev_id
            let res = await createdSkillApi(qs.stringify(req))
            if (res.data.code == 200) {
              this.$message({message: '创建技能成功', type: 'success'})
              window.location.href = '/skillList'
            } else if (res.data.code == 401) {
                window.location.href = '/login'
            } else {
              if (res.data.errors) {
                this.$message({message: res.data.errors.data, type: 'error'})
              } else {
                this.$message({message: '当前网络状况异常，请稍后再试', type: 'error'})
              }
            }
          },
          async SkillName () {
           let res = await skillName()
            if (res.status == 200) {
            this.options = res.data
            }
          }
        }
    }
</script>
<style  rel="stylesheet/scss" lang="scss">
  .createSkill-box{
    position: relative;
    width: 100%;
    height: 100%;
    .createSkillLeft{
      position: fixed;
      left: 0;
      top: 60px;
      margin-top: 27px;
      bottom: 0;
      width: 200px;
      border-right: 1px solid #f7f5f6;
      background: #fff url("../../../static/images/createSkillLeft.png") no-repeat center top;
    }
    .createSkillRight{
      position: absolute;
      left: 230px;
      right: 0;
      top: 60px;
      height: 100%;
      background: #fff;
      margin-top: 27px;
    }
    .el-form-item {
      position: relative;
      .blurIcon {
        color: #7abaf1;
        position: absolute;
        left: -18px;
      }
    }
  }
  #createSkill{
    background: #fff;
    .createSkill{
      background: #fff;
    }
    .SkillContainer{
      padding: 20px 30px;
      .el-textarea__inner {
        border-radius: 14px;
      }
      .little-btn {
        height: 28px;
        line-height: 8px;
        margin-left:10px;
      }
      .btnActive {
        background: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 16px;
      font-weight: 800;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    .el-input__inner{
      border-radius:20px;
      width: 216px;
      height: 28px;
      line-height: 28px;
    }
    button{
      margin-left:45%;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
    }
    .avatar {
      width: 120px;
      height: 120px;
      display: block;
    }
    .el-form-item__label{
      padding-right: 20px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/skilloverview/CreateSkill.vue